import {Component, OnDestroy, ViewEncapsulation} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {CoreConfig} from '../../../../../@core/types';
import {AuthenticationService} from '../../../../auth/service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss',
    encapsulation: ViewEncapsulation.None,
    standalone:false
})
export class ForgotPasswordComponent implements OnDestroy {

    // Public
    public coreConfig: CoreConfig;
    public loading = false;
    public submitted = false;
    public error = '';
    public passwordChangeRequested: boolean = false;
    public form = this._formBuilder.group({
        email: ['', [Validators.required, Validators.email]],
    });
    // Private
    private _onDestroy: Subject<void> = new Subject<void>();

    constructor(
        private _formBuilder: FormBuilder,
        private _authService:AuthenticationService
    ) {
    }

    ngOnDestroy(): void {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    onSubmit() {
        this.submitted = true;
        this.error= '';
        if (this.form.valid) {
            this.loading = true;
            this._authService.forgotPassword(this.form.value.email)
                .pipe(take(1))
                .subscribe({
                    next:()=>{
                        this.passwordChangeRequested = true;
                    },
                    error:(error) =>{
                        this.error = error;
                        this.loading = false;
                    },
                    complete:()=>{
                        this.loading = false;
                    }
                });
        }
    }
}
